import { call, put, select, takeLatest } from "redux-saga/effects";
import { actResult, slResult } from "./resultSlice";
import { API } from "../../api/types";
import { PayloadAction } from "@reduxjs/toolkit";
import ApiServices from "../../api/api";
import { groupBy } from "lodash";

const sortAscAdviceId = (
  a: API.ReadAdvicesRecordResponse,
  b: API.ReadAdvicesRecordResponse
) => a.toshiba_advice_id - b.toshiba_advice_id;

function* readAdvices(action: PayloadAction<API.ReadAdvicesRequest>) {
  try {
    const res: API.ReadAdvicesResponse = yield call(
      ApiServices.readAdvicesApi,
      action.payload
    );

    const advicesRes: API.ReadAdvicesRecordResponse[] | undefined =
      res.body.advice?.sort(sortAscAdviceId);

    const advicesGroup = groupBy(advicesRes, (a) => a.type);
    // ppw("readAdvices().advicesGroup", advicesGroup);

    const advices: API.ResultAdvicesModel = {
      got: advicesGroup["got"],
      ldl: advicesGroup["ldl"],
      sbp: advicesGroup["sbp"],
      hba1c: advicesGroup["hba1c"],
      scr: advicesGroup["scr"],
      tg: advicesGroup["tg"],
      hdl: advicesGroup["hdl"],
      rgtp: advicesGroup["rgtp"],
      dbp: advicesGroup["dbp"],
    };
    // ppw("readAdvices().advices", advices);
    yield put(actResult.setAdvices(advices));
  } catch (error) {
    console.error(error);
  } finally {
    yield put(actResult.readAdvicesDone());
  }
}

function* createReaction(action: PayloadAction<API.CreateReactionRequest>) {
  try {
    const reactionReq = action.payload;
    const res: API.CreateReactionResponse = yield call(
      ApiServices.createReactionApi,
      reactionReq
    );

    const { predictId } = yield select(slResult);
    if (predictId === undefined) return;
    const adviceReq: API.ReadAdvicesRequest = {
      id: predictId,
    };
    yield put(actResult.readAdvices(adviceReq));
  } catch (error) {
    console.error(error);
  } finally {
    yield put(actResult.createReactionDone());
  }
}

export default function* resultWatcherSaga() {
  yield takeLatest(actResult.readAdvices.type, readAdvices);
  yield takeLatest(actResult.createReaction.type, createReaction);
}
